import type { Account } from '@b-stock/account-api-client'
import {
  getAccountsClient,
  makeAuthenticatedQuery,
} from '@b-stock/fe-core/bstock-next/queries'
import { buildAxiosRequestConfig } from '@b-stock/fe-core/bstock-react'

import useAccountId from './useAccountId'

export const getAccount = async (
  accessToken: string | null,
  accountId: string
): Promise<Account> => {
  const accountsClient = getAccountsClient()

  const { data: account } = await accountsClient.getAccount(
    { id: accountId },
    buildAxiosRequestConfig({ accessToken })
  )

  return account
}

export const accountQuery = makeAuthenticatedQuery('accountById', getAccount)

const useAccount = (accountIdParam?: string) => {
  const accountIdFromHook = useAccountId()
  const accountId = accountIdParam ?? accountIdFromHook ?? ''

  return accountQuery.useWithOpts([accountId], { enabled: !!accountId })
}

export default useAccount
